export default Object.freeze({
  BROWSE_DROPDOWN_CLICKED: 'Browse shop dropdown clicked',
  LEFT_SIDEBAR_CLICKED: 'Left sidebar in an aisle clicked',
});
